import React from 'react';
import { Link } from 'react-router-dom';

const AcessoNegado = () => {
    return (
        <div className="container py-5">
            <div className="row">
                <div className="col-md-2 text-center">
                    <p><i className="fa fa-exclamation-triangle fa-5x"></i><br />Código: 403</p>
                </div>
                <div className="col-md-10">
                    <h3>OPPSSS!!!! Desculpe, mas você está sem permissão para acessar esta funcionalidade.</h3>
                    <p>Para solicitar acesso a ferramenta, entre em contato com o ServiceDesk atraves da ferramenta do Univirtus.<br /></p>
                    <Link to="/login">Voltar</Link>.
                </div>
            </div>
        </div>
    );
};

export default AcessoNegado;